const LANDING_INTRO = [
  {
    src: new URL(
      '~/public/assets/images/Landing/landingIntro.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/landingIntro.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/landingIntro.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default LANDING_INTRO
